import {HsOAuth2Service} from '../../libs/ui/src/index';

import {client} from '../apiService';
const _HsOAuth2Service = new HsOAuth2Service({client});
export {_HsOAuth2Service as HsOAuth2Service};
